import charansingh from "../assets/charansingh.jpg";
import Sidhu from "../assets/Sidhu.jpg";
import shivji from "../assets/shivji.jpg";
import ganeshji from "../assets/ganeshji.jpg";
import ironman from "../assets/ironman.jpg";
import kohli from "../assets/kohli.jpg";
import krishna from "../assets/krishna.jpg";
import rasmika from "../assets/rasmika.jpg";
import sonusood from "../assets/sonusood.jpg";


const Artworklist = [
  {
    
    image: Sidhu,
    
  },
  {
  image:charansingh
  },
  {
   image:shivji
  },
  {
   image:ganeshji
  },
  {
   image:ironman
  },
  {
   
    image: kohli,
    
  },
  {
   
    image: krishna,
  },
  {
   
    image: rasmika,
  },
  {
   
    image: sonusood,
  },
];

export default Artworklist;